import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as Forge from 'node-forge';
import * as _ from 'lodash';
import { environment } from 'src/environments/environment';
import SignUpResponse from '../interfaces/auth/SignUpResponse';
import { Observable } from 'rxjs';
import LoginResponse from '../interfaces/auth/LoginResponse';
import LoginRequest from '../interfaces/auth/LoginRequest';


@Injectable({
	providedIn: 'root'
})
export class AuthService {
	public requestAPIurl: any = environment.apiURL;
	public loggedIn: boolean = false;
	public isAdmin: boolean = false;
	constructor(private http: HttpClient) {
		let user = JSON.parse(sessionStorage.getItem('logged-in-user'));
		if (user && !_.isEmpty(user)) {
			this.loggedIn = true;
			if (user.role == 'A')
				this.isAdmin = true;
		}
	}

	getPublicKey() {
		return this.http.get(`${this.requestAPIurl}/api/keys/publicKey`);
	}

	encryptWithPublicKey(valueToEncrypt: string, publicKey): string {
		const rsa = Forge.pki.publicKeyFromPem(publicKey);
		var plaintextBytes = Forge.util.encodeUtf8(valueToEncrypt);
		return window.btoa(rsa.encrypt(plaintextBytes));
	}

	public encrypt(payload, publicKey) {
		if (publicKey != null) {
			return this.encryptWithPublicKey(
				JSON.stringify(payload), publicKey
			);
		}
		return null;
	}

	public signUp(body): Observable<SignUpResponse> {
		return this.http.post<SignUpResponse>(`${this.requestAPIurl}/api/user/signup`, body);
	}

	public login(body: LoginRequest): Observable<LoginResponse> {
		return this.http.post<LoginResponse>(`${this.requestAPIurl}/api/user/login`, body);
	}

	public logout() {
		let user = JSON.parse(sessionStorage.getItem('logged-in-user'));
		return this.http.post(`${this.requestAPIurl}/api/user/logout`, {
			userId: user._id
		});
	}


}
